export const LOAD_CMS_CHALLENGES_REQUEST = 'CMSAllChallenges/LOAD_CMS_CHALLENGES_REQUEST';
export const LOAD_CMS_CHALLENGES_SUCCESS = 'CMSAllChallenges/LOAD_CMS_CHALLENGES_SUCCESS';
export const LOAD_CMS_CHALLENGES_FAILURE = 'CMSAllChallenges/LOAD_CMS_CHALLENGES_FAILURE';
